module.exports = __webpack_public_path__ + "static/media/3d-banner.5dc3a048.png";